import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

const categoryImages: Record<string, string> = {
  "celebrity-scandal": "https://readdy.ai/api/search-image?query=Luxurious%20minimalist%20editorial%20photography%20of%20a%20single%20red%20carpet%20with%20golden%20velvet%20rope%2C%20warm%20dramatic%20spotlight%2C%20cream%20background%2C%20elegant%20atmosphere%2C%20high%20detail%2C%20sophisticated%20aesthetic&width=600&height=400&seq=channel-celebrity&orientation=landscape",
  society: "https://readdy.ai/api/search-image?query=Artistic%20editorial%20photography%20of%20abstract%20people%20silhouettes%20in%20conversation%2C%20warm%20golden%20ambient%20lighting%2C%20cream%20background%2C%20minimalist%20composition%2C%20social%20commentary%20theme%2C%20clean%20aesthetic&width=600&height=400&seq=channel-social&orientation=landscape",
  "viral-memes": "https://readdy.ai/api/search-image?query=Dynamic%20editorial%20photography%20of%20colorful%20digital%20wave%20patterns%20with%20viral%20energy%2C%20warm%20amber%20and%20coral%20tones%2C%20cream%20background%2C%20minimalist%20composition%2C%20modern%20tech%20aesthetic&width=600&height=400&seq=channel-viral&orientation=landscape",
  "deep-dive": "https://readdy.ai/api/search-image?query=Elegant%20editorial%20photography%20of%20a%20magnifying%20glass%20over%20textured%20paper%2C%20warm%20golden%20lighting%2C%20cream%20background%2C%20minimalist%20investigation%20theme%2C%20sophisticated%20aesthetic%2C%20clean%20composition&width=600&height=400&seq=channel-deep&orientation=landscape",
  "daily-fresh": "https://readdy.ai/api/search-image?query=Fresh%20editorial%20photography%20of%20morning%20newspaper%20with%20warm%20sunlight%2C%20cream%20background%2C%20minimalist%20composition%2C%20golden%20hour%20lighting%2C%20clean%20journalism%20aesthetic%2C%20sophisticated&width=600&height=400&seq=channel-daily&orientation=landscape",
};

export default function ChannelMatrix() {
  const displayCategories = categories.slice(0, 3);
  const moreCategories = categories.slice(3);

  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="px-6 md:px-14">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
          <div>
            <span className="text-xs font-medium text-foreground-500 uppercase tracking-widest">热门频道</span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mt-2">探索你感兴趣的瓜</h2>
          </div>
          <div className="flex flex-wrap gap-2">
            {moreCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50 text-foreground-600 text-xs font-medium border border-background-200/70 hover:border-background-300/60 hover:text-foreground-950 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className={`${cat.icon} text-xs`}></i>
                {cat.name}
              </Link>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {displayCategories.map((cat, idx) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`group relative rounded-3xl overflow-hidden cursor-pointer ${
                idx === 0 ? "bg-foreground-950" : "bg-background-50 border border-background-200/70"
              } h-[340px] flex flex-col`}
            >
              {idx === 0 ? (
                <>
                  <div className="absolute top-5 left-5 w-12 h-12 rounded-2xl bg-white/10 flex items-center justify-center">
                    <i className={`${cat.icon} text-xl text-white`}></i>
                  </div>
                  <div className="mt-auto p-6">
                    <h3 className="text-2xl font-bold text-white mb-2">{cat.name}</h3>
                    <p className="text-white/60 text-sm leading-relaxed">{cat.description}</p>
                  </div>
                </>
              ) : idx === 1 ? (
                <>
                  <div className="flex-1 overflow-hidden">
                    <img
                      src={categoryImages[cat.slug] || categoryImages["celebrity-scandal"]}
                      alt={cat.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute top-4 left-4 px-3 py-1.5 rounded-full bg-foreground-950/60 backdrop-blur-sm text-white text-xs font-medium flex items-center gap-1.5">
                    <i className={`${cat.icon} text-xs`}></i>
                    {cat.name}
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-black/60 to-transparent">
                    <p className="text-white text-lg font-semibold">{cat.description}</p>
                  </div>
                </>
              ) : (
                <>
                  <div className="p-6 flex-1 flex flex-col">
                    <div className="w-12 h-12 rounded-2xl bg-primary-100 flex items-center justify-center mb-4">
                      <i className={`${cat.icon} text-xl text-primary-600`}></i>
                    </div>
                    <h3 className="text-4xl font-bold text-foreground-950 mb-2">10万+</h3>
                    <p className="text-foreground-500 text-sm mb-3">每日更新瓜料</p>
                    <p className="text-foreground-600 text-sm leading-relaxed mt-auto">{cat.description}</p>
                  </div>
                  <div className="h-[140px] overflow-hidden">
                    <img
                      src={categoryImages[cat.slug] || categoryImages["celebrity-scandal"]}
                      alt={cat.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                </>
              )}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
